/* ==========================================================================
   GSAP ScrollTrigger Animations — That's Coffee Theme
   Premium scroll animations for homepage sections
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  // Bail if GSAP or ScrollTrigger not loaded, or user prefers reduced motion
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);
  if (typeof SplitText !== 'undefined') gsap.registerPlugin(SplitText);

  // ── Video Hero v3: Ambient Coffee Canvas ──
  (function () {
    var heroSection = document.querySelector('.tc-video-hero');
    if (!heroSection) return;

    var tagline = heroSection.querySelector('.tc-video-hero__tagline');
    var subtitle = heroSection.querySelector('.tc-video-hero__subtitle');
    var ctaWrap = heroSection.querySelector('.tc-video-hero__cta-wrap');
    var steam = heroSection.querySelector('.tc-video-hero__steam');
    var content = heroSection.querySelector('.tc-video-hero__content');
    var overlay = heroSection.querySelector('.tc-video-hero__overlay');
    var cta = heroSection.querySelector('.tc-video-hero__cta');
    var depthTop = heroSection.querySelector('.tc-video-hero__depth--top');
    var depthBottom = heroSection.querySelector('.tc-video-hero__depth--bottom');

    // ─ SplitText: Character-by-character entrance ─
    if (tagline && typeof SplitText !== 'undefined') {
      var split = new SplitText(tagline, { type: 'chars' });
      gsap.set(split.chars, { opacity: 0, y: 60, rotateX: -90 });
      gsap.to(split.chars, {
        opacity: 1,
        y: 0,
        rotateX: 0,
        stagger: 0.04,
        duration: 0.8,
        ease: 'back.out(1.7)',
        delay: 0.5
      });
    }

    // ─ Subtitle fade-in after tagline ─
    if (subtitle) {
      gsap.set(subtitle, { opacity: 0, y: 15 });
      gsap.to(subtitle, {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        delay: 1.0
      });
    }

    // ─ Depth-text entrance: fade in gently ─
    if (depthTop || depthBottom) {
      var depthEls = [depthTop, depthBottom].filter(Boolean);
      gsap.set(depthEls, { opacity: 0 });
      gsap.to(depthEls, {
        opacity: 1,
        duration: 1.5,
        ease: 'power1.inOut',
        delay: 0.8
      });
    }

    // ─ CTA fade-in after text animation ─
    if (ctaWrap) {
      gsap.set(ctaWrap, { opacity: 0, y: 20 });
      gsap.to(ctaWrap, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        delay: 1.2
      });
    }

    // ─ Steam fade-in after CTA ─
    if (steam) {
      gsap.set(steam, { opacity: 0 });
      gsap.to(steam, {
        opacity: 1,
        duration: 1.0,
        ease: 'power1.in',
        delay: 1.5
      });
    }

    // ─ Scroll-reveal: Overlay wird transparenter → Video erwacht ─
    if (overlay) {
      gsap.to(overlay, {
        opacity: 0.35,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: '60% top',
          scrub: true
        }
      });
    }

    // ─ Content parallax: Text hebt sich beim Scrollen ─
    if (content) {
      gsap.to(content, {
        yPercent: -20,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    // ─ CTA parallax: Schneller als Content ─
    if (ctaWrap) {
      gsap.to(ctaWrap, {
        yPercent: -40,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    // ─ Depth-text parallax: Unterschiedliche Geschwindigkeiten ─
    if (depthTop) {
      gsap.to(depthTop, {
        yPercent: -50,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    if (depthBottom) {
      gsap.to(depthBottom, {
        yPercent: 30,
        ease: 'none',
        scrollTrigger: {
          trigger: heroSection,
          start: 'top top',
          end: 'bottom top',
          scrub: true
        }
      });
    }

    // ─ Magnetic CTA button (desktop only) ─
    if (cta && window.innerWidth >= 750) {
      cta.addEventListener('mousemove', function (e) {
        var rect = cta.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        gsap.to(cta, { x: x * 0.3, y: y * 0.3, duration: 0.4, ease: 'power2.out' });
      });
      cta.addEventListener('mouseleave', function () {
        gsap.to(cta, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.3)' });
      });
    }
  })();

  // ── Utility: Staggered fade-up for child elements ──
  function animateChildren(parentSelector, childSelector, options = {}) {
    const parents = document.querySelectorAll(parentSelector);
    parents.forEach(function (parent) {
      const children = parent.querySelectorAll(childSelector);
      if (!children.length) return;

      gsap.from(children, {
        y: options.y || 40,
        opacity: 0,
        duration: options.duration || 0.7,
        stagger: options.stagger || 0.12,
        ease: options.ease || 'power2.out',
        scrollTrigger: {
          trigger: parent,
          start: options.start || 'top 85%',
          once: true
        }
      });
    });
  }

  // ── USP Bar: Icons slide up one by one ──
  animateChildren('.tc-usp-bar', '.tc-usp-bar__item', {
    y: 30,
    stagger: 0.1,
    duration: 0.5
  });

  // ── Bento Grid: Cards fly in with staggered delays ──
  animateChildren('.tc-bento-grid', '.tc-bento-card', {
    y: 60,
    stagger: 0.15,
    duration: 0.8,
    ease: 'power3.out'
  });

  // ── Bento Grid: 3D Tilt on Hover (Desktop only) ──
  (function () {
    if (window.innerWidth < 990) return;

    var bentoCards = document.querySelectorAll('.tc-bento-card');
    if (!bentoCards.length) return;

    bentoCards.forEach(function (card) {
      var link = card.querySelector('.tc-bento-card__link');
      var products = card.querySelectorAll('.tc-bento-card__product');
      if (!link) return;

      var maxRotation = 8;
      var parallaxStrength = 15;

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;

        gsap.to(link, {
          rotateY: x * maxRotation,
          rotateX: -y * maxRotation,
          duration: 0.4,
          ease: 'power2.out',
          overwrite: 'auto'
        });

        products.forEach(function (product, i) {
          var depth = (i === 1) ? parallaxStrength * 1.2 : parallaxStrength;
          gsap.to(product, {
            x: -x * depth,
            y: -y * depth,
            duration: 0.4,
            ease: 'power2.out',
            overwrite: 'auto'
          });
        });
      });

      card.addEventListener('mouseleave', function () {
        gsap.to(link, {
          rotateY: 0,
          rotateX: 0,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)',
          overwrite: 'auto'
        });

        products.forEach(function (product) {
          gsap.to(product, {
            x: 0,
            y: 0,
            duration: 0.6,
            ease: 'elastic.out(1, 0.5)',
            overwrite: 'auto'
          });
        });
      });
    });
  })();

  // ── Testimonials: Fade in from sides ──
  var testimonialCards = document.querySelectorAll('.multicolumn-card');
  if (testimonialCards.length) {
    gsap.from(testimonialCards, {
      x: function (i) { return i % 2 === 0 ? -40 : 40; },
      opacity: 0,
      duration: 0.7,
      stagger: 0.15,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: testimonialCards[0].closest('section') || testimonialCards[0].parentElement,
        start: 'top 85%',
        once: true
      }
    });
  }

  // ── Benefits / Coffeebag Features: Cards scale up ──
  animateChildren('.tc-coffeebag-features, [class*="coffeebag-features"]', '.tc-feature-card, .multicolumn-card', {
    y: 50,
    stagger: 0.12,
    duration: 0.7
  });

  // ── Barista CTA: Parallax on background image ──
  var baristaCta = document.querySelector('.tc-barista-cta');
  if (baristaCta) {
    var bgImage = baristaCta.querySelector('.tc-barista-cta__bg, img');
    if (bgImage) {
      gsap.to(bgImage, {
        yPercent: 15,
        ease: 'none',
        scrollTrigger: {
          trigger: baristaCta,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1
        }
      });
    }

    // Course cards stagger in
    animateChildren('.tc-barista-cta', '.tc-barista-cta__course, .tc-course-card', {
      y: 40,
      stagger: 0.1,
      duration: 0.6
    });
  }

  // ── Image with Text sections: Slide in from sides ──
  document.querySelectorAll('.image-with-text').forEach(function (section) {
    var image = section.querySelector('.image-with-text__media, .media');
    var text = section.querySelector('.image-with-text__content, .rich-text');

    if (image) {
      gsap.from(image, {
        x: -60,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: { trigger: section, start: 'top 80%', once: true }
      });
    }
    if (text) {
      gsap.from(text, {
        x: 60,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: { trigger: section, start: 'top 80%', once: true }
      });
    }
  });

  // ── Generic: Headings with reveal animation ──
  document.querySelectorAll('h2.title, .section-header__title, .title--primary').forEach(function (heading) {
    // Skip if already inside an animated parent
    if (heading.closest('.tc-bento-grid, .tc-usp-bar, .tc-barista-cta')) return;

    gsap.from(heading, {
      y: 30,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: heading,
        start: 'top 90%',
        once: true
      }
    });
  });

  // ── Footer: Subtle fade up ──
  var footer = document.querySelector('.coffee-footer .footer__container');
  if (footer) {
    gsap.from(footer, {
      y: 20,
      opacity: 0,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: footer,
        start: 'top 95%',
        once: true
      }
    });
  }

  // ── Product Page: Premium Animations ──
  (function () {
    var productSection = document.querySelector('[id^="MainProduct-"]');
    if (!productSection) return;

    var productInfo = productSection.querySelector('.product__info-wrapper');
    if (!productInfo) return;

    // ─ Product Info: Staggered block entrance ─
    var infoBlocks = productInfo.querySelectorAll(
      '.product__title, .subtitle, .tc-coffee-profile, .price, ' +
      '.product-form__input, .product-form__buttons, .icon-with-text, ' +
      '.product__description, .product__accordion'
    );

    if (infoBlocks.length) {
      gsap.set(infoBlocks, { opacity: 0, y: 25 });
      gsap.to(infoBlocks, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.08,
        ease: 'power2.out',
        delay: 0.2
      });
    }

    // ─ Coffee Profile: Animated bars fill ─
    var profileCards = productSection.querySelectorAll('.tc-coffee-profile');
    profileCards.forEach(function (card) {
      if (card.style.display === 'none') return;

      var bars = card.querySelectorAll('.tc-coffee-profile__bar-fill');
      var tags = card.querySelectorAll('.tc-coffee-profile__tag');

      gsap.to(bars, {
        scaleX: 1,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power2.out',
        delay: 0.6
      });

      if (tags.length) {
        gsap.set(tags, { opacity: 0, y: 8 });
        gsap.to(tags, {
          opacity: 1,
          y: 0,
          duration: 0.4,
          stagger: 0.06,
          ease: 'power2.out',
          delay: 1.0
        });
      }
    });

    // ─ Gallery: Fade in media items ─
    var galleryItems = productSection.querySelectorAll('.product__media-item');
    if (galleryItems.length) {
      gsap.from(galleryItems, {
        opacity: 0,
        scale: 0.97,
        duration: 0.7,
        stagger: 0.1,
        ease: 'power2.out',
        delay: 0.1
      });
    }

    // ─ Variant Change: Re-animate visible coffee profile ─
    var specialitySelector = document.querySelector('select[name="options[Sorte]"]');
    if (specialitySelector) {
      specialitySelector.addEventListener('change', function () {
        setTimeout(function () {
          var visibleCard = productSection.querySelector(
            '.tc-coffee-profile[style*="display: flex"]'
          );
          if (!visibleCard) return;

          var bars = visibleCard.querySelectorAll('.tc-coffee-profile__bar-fill');
          var tags = visibleCard.querySelectorAll('.tc-coffee-profile__tag');

          gsap.fromTo(bars, { scaleX: 0 }, {
            scaleX: 1, duration: 0.6, stagger: 0.1, ease: 'power2.out'
          });

          if (tags.length) {
            gsap.fromTo(tags, { opacity: 0, y: 6 }, {
              opacity: 1, y: 0, duration: 0.3, stagger: 0.05, ease: 'power2.out', delay: 0.3
            });
          }
        }, 50);
      });
    }
  })();
});
